(function () {
    'use strict';

    angular.module('notes')
        .directive('notes', notes);

    function notes() {
        return {
            restrict: 'E',
            templateUrl: 'layout/notesTemplate.html',
            controller: directiveController,
            scope: {
                onEdit: '&'
            }
        };
    }

    function directiveController($scope, NotesService, DataService, userService) {
        $scope.notes = NotesService.getNotes();
        $scope.notesType = DataService.getNotesType();

        $scope.modifyNote = function (index) {
            NotesService.modifyNote($scope.editedNotes.data[index], function (data) {
                $scope.notes.data[index] = data;
                if ($scope.onEdit) {
                    $scope.onEdit();
                }
            });
        }

        $scope.$watch('notes', function () {
            $scope.editedNotes = angular.copy($scope.notes);
            NotesService.obj.pastabuKiekis = $scope.notes.data.length;
        }, true);

        $scope.$on('reloadNotes', function() {
            $scope.notes = NotesService.getNotes();
        });

        $scope.canRemoveNote = function (note) {
            return userService.canEditObject(note.createdByCurrentUser);
        }
    }
})();
